import React from "react";
import { baseYtUrl } from "../../config/config";

import "./VideoPlayer.scss";

const VideoPlayer = ({ videoId }) => {
  //   const videoId = "3iv2r_h3dYE/";
  const Trailer = { videoId };
  // console.log(Trailer?.videoId?.[0]?.key, "@@@@");
  return (
    <>
      {/* {console.log("Trailer", Trailer?.[0]?.key)} */}

      <div className="video-player">
        {/* <div className="video-name">{Trailer?.videoId?.[0]?.name}</div> */}

        <iframe
          width="700"
          height="472"
          title="JazzMovies"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen="1"
          src={`${baseYtUrl}${Trailer?.videoId?.[0]?.key}?controls=1&autoplay=0&mute=1&fullscreen=1`}
        ></iframe>
      </div>
    </>
  );
};

export default VideoPlayer;
